import { render } from "./QuotesHome.vue?vue&type=template&id=42148d34&scoped=true"
import script from "./QuotesHome.vue?vue&type=script&lang=js"
export * from "./QuotesHome.vue?vue&type=script&lang=js"

import "./QuotesHome.vue?vue&type=style&index=0&id=42148d34&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42148d34"]])

export default __exports__